import request from '@/axios'

export function get_lesson_note_list (customer_id, page, payload, filter_id, sorting_obj, table_name) {
  let url = ''
  if (Object.entries(sorting_obj).length > 0) {
    url = filter_id ? `V1/note/list/${customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&filter_id=${filter_id}` : `V1/note/list/${customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}`
  } else {
    url = filter_id ? `V1/note/list/${customer_id}?table_name=${table_name}&page=${page}&filter_id=${filter_id}` : `V1/note/list/${customer_id}?table_name=${table_name}&page=${page}`
  }
  return request({
    url,
    method: 'POST',
    data: payload
  })
}

export function createNote (customer_id, payload) {
  return request({
    url: `V1/note/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function updateNote (customer_id, payload, note_id) {
  return request({
    url: `V1/note/update/${customer_id}/${note_id}`,
    method: 'POST',
    data: payload
  })
}
export function attachNoteToCourse (customer_id, note_id, payload) {
  return request({
    url: `V1/note/attachToCourse/${customer_id}/${note_id}`,
    method: 'POST',
    data: payload
  })
}

export function assignToNote (customer_id, note_id, payload) {
  return request({
    url: `V1/note/share/${customer_id}/${note_id}`,
    method: 'POST',
    data: payload
  })
}

export function deleteNoteTemplate (customer_id, note_id) {
  return request({
    url: `V1/note/delete/${customer_id}/${note_id}`,
    method: 'POST'
  })
}
  

export function notesDownload (customer_id, note_id) {
  return request({
    url: `V1/schedule/note/download/${customer_id}/${note_id}`,
    method: 'GET'
  })
}